import { IoCContainer } from '@lmnop/web-core';
import { WebsiteCoreIoCKeys, IWebsiteCoreIoCContainer, IWebsiteCoreSettings } from 'website-core-src';
import { CoreModulesIoC } from './core-modules-ioc.class';

export class WebsiteCoreIoCContainer implements IWebsiteCoreIoCContainer {
    public lateBindIoC(): void {
        this.core = new CoreModulesIoC();
        this.settings = IoCContainer.get(WebsiteCoreIoCKeys.IWebsiteCoreSettings);
    }

    public core: CoreModulesIoC;
    public settings: IWebsiteCoreSettings;
}
